// Shared Google Maps configuration to ensure consistent loader options
// across all components that use Google Maps APIs

export const GOOGLE_MAPS_LIBRARIES = ["geometry", "drawing", "places"];

export const GOOGLE_MAPS_CONFIG = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
